import { render, staticRenderFns } from "./revolvente.vue?vue&type=template&id=5a211da1&"
import script from "./revolvente.vue?vue&type=script&lang=js&"
export * from "./revolvente.vue?vue&type=script&lang=js&"
import style0 from "./revolvente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports